var data = { header:{ text:"#### Fixed gene list",
    closeButton:true },
  body:{ text:"This test is not customizable at this time." },
  buttons:[ { text:"OK",
      isPrimary:true,
      action:"clearCart" } ] };
data.header;
data.body;
data.buttons;

export { data as default };
//# sourceMappingURL=locked_gene.esm.js.map
